import PureLoadable from 'UI/lib/PureLoadable';

const SkillExpertise = PureLoadable({
  loader: () => import('./SkillExpertise.jsx'),
  displayName: 'SkillExpertise',
});

export default SkillExpertise;
